import { render, staticRenderFns } from "./CloseDatePastDueTable.vue?vue&type=template&id=f34977c0"
import script from "./CloseDatePastDueTable.vue?vue&type=script&lang=js"
export * from "./CloseDatePastDueTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports